export default "__VITE_ASSET__q6C$XZy4__"